import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/tire-good-received-components'
import { theme } from '../../../styles/_variables'
import { STATUS, STATUSTEXTSELECTOR, STATUSCOLORSELECTOR } from '../constants'

const { color } = theme

export default {
  columns: [{
    Header: () => <HeaderLabel>วันที่รับ</HeaderLabel>,
    accessor: 'createdAt',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>หมายเลขใบรับสินค้า</HeaderLabel>,
    accessor: 'refId',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>หมายเลขใบสั่งซื้อ</HeaderLabel>,
    accessor: 'PurchaseOrder.number',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ผู้ผลิต</HeaderLabel>,
    accessor: 'Supplier.name',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 300,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>หมายเลข ref ของ supplier</HeaderLabel>,
    accessor: 'supplierRefId',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ชื่อผู้รับสินค้า</HeaderLabel>,
    accessor: 'User.firstname',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>นามสกุลผู้รับสินค้า</HeaderLabel>,
    accessor: 'User.lastname',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
